import { render, staticRenderFns } from "./Build.vue?vue&type=template&id=3bb75431&scoped=true"
import script from "./Build.vue?vue&type=script&lang=js"
export * from "./Build.vue?vue&type=script&lang=js"
import style0 from "./Build.vue?vue&type=style&index=0&id=3bb75431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb75431",
  null
  
)

export default component.exports